import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 反馈意见接口
export function getFeedBack(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/feedbacks',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 系统-激活订阅码接口
export function getSubscriptionCode(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/subscription_codes/_activate',
        method: 'post',
        params: {
            code: data
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-投票-我的投票列表接口
export function getVotesList(data) {
    var sign = getRequest({});
    return request({
        url: '/v4/users/my_votes',
        method: 'get',
        params: {},
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-我的购买记录接口
export function getPurchasesList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/purchases',
        method: 'get',
        params: {
            page: params.page,
            per: params.per
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-重置密码接口(一财总部接口)
export function getEditPwd(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/yicai_users/reset_password',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-找回密码发送验证码接口(忘记密码)
export function getForgetCode(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/yicai_users/forgot_pwd_sms',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 快速登录，获取验证码
export function getFastCode(data) {
    var sign = getRequest(data);
    return request({
        url: '/v5/yicai_users/new_users_sms',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 快速登录
export function getFastLogin(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/users/sign_in',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
//用户-购买记录-申请发票接口 
export function getDrawBill(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/invoices/set_invoice',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-统计-用户主页各项分类数据统计接口
export function getStatisticsList() {
    var sign = getRequest({});
    return request({
        url: '/v4/users/statistics',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-获取开票详情接口
export function getVoiceDetailList(id) {
    var sign = getRequest(id);
    return request({
        url: '/v4/invoices/get_invoices',
        method: 'get',
        params: {
            order_id: id
        },
        headers: {
            'X-Signature': sign
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/system.js